import {AlertTriangle, Loader2} from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

import {acknowledgeResidentHouseholdForbiddenRecovery} from "../lib/resident-context-household-forbidden";
import {useResidentHouseholdForbiddenPendingStore} from "../store/resident-household-forbidden-pending";

const CONTINUE_LABEL = "Continue";

export function ResidentHouseholdForbiddenDialog() {
  const pending = useResidentHouseholdForbiddenPendingStore((s) => s.pending);
  const isRecovering = useResidentHouseholdForbiddenPendingStore((s) => s.isRecovering);

  return (
    <AlertDialog open={pending != null} onOpenChange={() => {}}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="text-destructive size-4 shrink-0" />
            Unit access changed
          </AlertDialogTitle>
          <AlertDialogDescription className="flex flex-col gap-2">
            <span>{pending?.message}</span>
            <span>
              When you continue, we&apos;ll switch you to your next available home and refresh this
              screen.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            type="button"
            className="w-full sm:w-auto"
            disabled={isRecovering}
            onClick={(event) => {
              event.preventDefault();
              void acknowledgeResidentHouseholdForbiddenRecovery();
            }}
          >
            {isRecovering ? <Loader2 className="size-4 animate-spin" /> : null}
            {CONTINUE_LABEL}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
